import axios from 'axios'
import type { PayloadEnv } from '~~/types'
/**
 * Triggers the GitHub Actions workflow dispatch API for webview automation.
 * @param {Env} env - The environment (e.g., "venus").
 * @param {string} scenarios - The scenarios to run (e.g., "tc-001.spec.ts" or "all").
 */

export default async function dispatchGithubWorkflowWebview(env: PayloadEnv, scenarios: string) {
  const { githubActionToken } = useRuntimeConfig().public
  const token = githubActionToken
  let id = ''
  switch (env) {
    case 'ballbot':
      id = 'playwright-vendor-webview-ballbot.yml'
      break
    case 'venus':
      id = 'playwright-vendor-webview-venus.yml'
      break
    case 'production':
      id = 'playwright-vendor-webview-prod.yml'
      break
    case 'prod-support':
      id = 'playwright-vendor-webview-prod-support.yml'
      break
    default:
      id = 'playwright-vendor-webview-ballbot.yml'
      break
  }
  const url = `https://api.github.com/repos/hungryhub-team/hhvendor-automation/actions/workflows/${id}/dispatches`
  if (!token) {
    return {
      status: 'error',
      message: 'GITHUB_ACTION_TOKEN is not set in the .env file.',
    }
  }

  const payload = {
    ref: 'main',
    inputs: {
      env,
      scenarios,
      triggerFrom: 'Dashboard Automation Testing (Webview)',
    },
  }

  try {
    const response = await axios.post(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/vnd.github.v3+json',
      },
    })

    if (response.status === 204) {
      return {
        success: true,
        message: 'Webview workflow triggered successfully.',
      }
    }

    return {
      status: 'error',
      message: 'Unexpected response from the server.',
    }
  } catch (error) {
    const errResponse = (error as any).response
    if (errResponse?.status === 422 && errResponse?.data?.message) {
      return {
        success: false,
        message: errResponse.data.message,
      }
    }
    return {
      success: false,
      message: errResponse?.data?.message || (error as Error).message || 'An unknown error occurred.',
    }
  }
}
